import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MorningFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const MorningFilledIcon: React.FC<MorningFilledIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path d="M16 9.6611H14.2222V8.1611H16V9.6611Z" fill={colors[color]} />
      <Path
        d="M8.75 1.79999V3.57777H7.25V1.79999L8.75 1.79999Z"
        fill={colors[color]}
      />
      <Path
        d="M0 9.6611H1.77778L1.77778 8.1611H6.55664e-08L0 9.6611Z"
        fill={colors[color]}
      />
      <Path
        d="M3.06993 5.93014L1.81285 4.67307L2.87351 3.61241L4.13059 4.86948L3.06993 5.93014Z"
        fill={colors[color]}
      />
      <Path
        d="M13.1269 3.61327L11.8698 4.87035L12.9305 5.93101L14.1876 4.67393L13.1269 3.61327Z"
        fill={colors[color]}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8292 11.7167C13.0648 11.1233 13.1944 10.4764 13.1944 9.79996C13.1944 6.93115 10.8688 4.60552 8 4.60552C5.13119 4.60552 2.80556 6.93115 2.80556 9.79996C2.80556 10.4764 2.93516 11.1233 3.17084 11.7167H0.888889L0.888889 13.2167H4.06954L4.44444 13.2171L15.1111 13.2167V11.7167H12.8292ZM8 6.10552C5.95961 6.10552 4.30556 7.75958 4.30556 9.79996C4.30556 10.5026 4.50108 11.1581 4.84088 11.7167L11.1591 11.7167C11.4989 11.1581 11.6944 10.5026 11.6944 9.79996C11.6944 7.75958 10.0404 6.10552 8 6.10552Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

MorningFilledIcon.displayName = 'MorningFilledIcon';

export { MorningFilledIcon };
